import { axiosAuthInstance } from '../utils/getSubdomain'

export const getProfile = () => {
  return axiosAuthInstance.get('/profile/')
}

export const saveFCMToken = (fcm_token: string) => {
  return axiosAuthInstance.post('/save-fcm-token/', {
    fcm_token,
  })
}
